module.exports = "../fonts/HelveticaNeueLTW01-45Light.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-45Light.woff2
// module id = 7YZo
// module chunks = 1